<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.97913 10L4.16663 6.16667L5.33329 5L10.3333 10L5.33329 15L4.16663 13.8333L7.97913 10ZM13.4791 10L9.66663 6.16667L10.8333 5L15.8333 10L10.8333 15L9.66663 13.8333L13.4791 10Z" fill="#333333"/>
</svg>
